import { render, staticRenderFns } from "./orderXq.vue?vue&type=template&id=ac9a7210&scoped=true&"
import script from "./orderXq.vue?vue&type=script&lang=js&"
export * from "./orderXq.vue?vue&type=script&lang=js&"
import style0 from "./orderXq.vue?vue&type=style&index=0&id=ac9a7210&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac9a7210",
  null
  
)

export default component.exports